<template>
    <button
        @click="onClick"
        v-bind="$attrs"
        :class="{
            '!hidden': !state.isApp,
        }"
    >
        <slot></slot>
    </button>
</template>

<script setup>
import { onMounted, defineProps, reactive } from "vue";

const state = reactive({
    isApp: false,
});

const onClick = async () => {
    if (state.isApp) {
        window.ReactNativeWebView.postMessage(
            JSON.stringify({
                action: "billing",
            })
        );
    }
};

onMounted(() => {
    if (window.ReactNativeWebView) {
        document.querySelectorAll(".mobile-only-button").forEach((element) => {
            element.style.display = "block";
        });
        document.querySelectorAll(".web-only-button").forEach((element) => {
            element.style.display = "none";
        });
        state.isApp = true;
    }
});
</script>

<style scoped></style>
